import { render, staticRenderFns } from "./collectionCardNetwork.vue?vue&type=template&id=329f457d&scoped=true&"
import script from "./collectionCardNetwork.vue?vue&type=script&lang=js&"
export * from "./collectionCardNetwork.vue?vue&type=script&lang=js&"
import style0 from "./collectionCardNetwork.vue?vue&type=style&index=0&id=329f457d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329f457d",
  null
  
)

export default component.exports